import { combineReducers } from 'redux';
import calendar from './calendar';
import dashboard from './dashboard';
import importing from './import';
import importRules from './importRules';
import windowSize from './windowSize';
import url from './url';
import plaid from './plaid';
import settings from './settings';
import transactions from './transactions';
import sharing from './sharing';
import login from './login';
import mealIdeas from './mealIdeas';
import food from './food';

const rootReducer = (state, action) => {
	const allState = {};

	const reducers = {
		settings,
		calendar,
		dashboard,
		windowSize,
		plaid,
		sharing,
		login,
		importing,
		importRules,
		mealIdeas,
		food,
	};
	if(!state) {
		state = {};
	}
	for(let index in reducers) {
		const reducer = reducers[index];
		allState[index] = reducer(state[index], action);
	}

	allState.transactions = transactions(state.transactions, action, allState);
	allState.url = url(state.url, action, allState);
	return allState;
};

export default rootReducer;
